import { HttpErrorResponse } from "@angular/common/http";
import { Component, Input, OnDestroy, OnInit } from "@angular/core";
import { Subscription } from "rxjs";
import { first } from "rxjs/operators";
import { Login } from "../../models/login.model";
import { Utilities } from "../../models/utilities.model";
import { AlertService, MessageSeverity } from "../../services/alert.service";
import { AuthService } from "../../services/auth.service";

@Component({
    selector: "app-login",
    templateUrl: './login.component.html',
    styleUrls: ['./login.component.scss'],
    standalone: false
})

export class LoginComponent implements OnInit, OnDestroy {

  modalClosedCallback: () => void;
  userLogin: Login = new Login();
  isLoading = false;
  formResetToggle = true;

  @Input() isModal = false;

  private loginStatusSubscription: Subscription;

  constructor(private alertService: AlertService, private authService: AuthService) {
  }

  ngOnInit(): void {
    this.userLogin.rememberMe = this.authService.rememberMe;

    if (this.getShouldRedirect()) {
      this.authService.redirectLoginUser();
    }
    else {
      this.loginStatusSubscription = this.authService.getLoginStatusEvent().subscribe(isLoggedIn => {
        if (this.getShouldRedirect()) {
          this.authService.redirectLoginUser();
        }
      });
    }
  }

  ngOnDestroy(): void {
    if (this.loginStatusSubscription) {
      this.loginStatusSubscription.unsubscribe();
    }
  }

  login() {
    this.isLoading = true;
    this.alertService.startLoadingMessage('', 'Anmeldung läuft...');

    this.authService.login(this.userLogin.userName, this.userLogin.password, this.userLogin.rememberMe)
      .subscribe(
        user => {
          setTimeout(() => {
            this.alertService.stopLoadingMessage();
            this.isLoading = false;
            this.reset();

            let loginheader: string = 'Login';
            let firstName: string = (user.firstName) ? user.firstName : user.userName;
            let lastName: string = (user.lastName) ? user.lastName : "";

            if (!this.isModal) {
              if (firstName && lastName) {
                this.alertService.showMessage(loginheader, 'Willkommen ' + firstName + ' ' + lastName, MessageSeverity.success);
              } else {
                this.alertService.showMessage(loginheader, 'Willkommen ' + user.userName, MessageSeverity.success);
              }
            }
            else {
              if (firstName && lastName) {
                this.alertService.showMessage(loginheader, 'Sitzung für ' + firstName + ' ' + lastName + ' wiederhergestellt!', MessageSeverity.success);
              } else {
                this.alertService.showMessage(loginheader, 'Sitzung für ' + user.userName + ' wiederhergestellt!', MessageSeverity.success);
              }

              setTimeout(() => {
                var header = 'Sitzung wiederhergestellt';
                var message = 'Bitte versuchen Sie Ihre letzte Operation noch einmal!';
                this.alertService.showStickyMessage(header, message, MessageSeverity.default);
              }, 500);

              this.closeModal();
            }
          }, 500);
        },
        error => {

          this.alertService.stopLoadingMessage();

          if (Utilities.checkNoNetwork(error)) {
            this.alertService.showStickyMessage(Utilities.noNetworkMessageCaption, Utilities.noNetworkMessageDetail, MessageSeverity.error, error);
          }
          else {
            let errorMessage = Utilities.findHttpResponseMessage("error_description", error);
            let loginErrorHeader: string = 'Anmeldefehler';

            if (errorMessage) {
              this.alertService.showStickyMessage(loginErrorHeader, errorMessage, MessageSeverity.error, error);
            }
            else {
              if (error && error.error && error.error.error && error.error.error == "invalid_grant" && (error.error.errorDescription || error.error.error_description)) {
                let description: string = error.error.error_description ? error.error.error_description : error.error.errorDescription;
                let messageContent = '';
                if (description && description.includes('CORE.ALERTS.LOGIN.ERRORUSERDATA')) {
                  messageContent = 'Die Anmeldedaten sind ungültig. Bitte überprüfe Benutzername/E-Mail Adresse und Kennwort.';
                } else if (description && description.includes('CORE.ALERTS.LOGIN.ERRORUSERSUSPEND')) {
                  messageContent = 'Das angegebene Benutzerkonto wurde gesperrt.';
                } else {
                  messageContent = error.error.error_description;
                }
                this.alertService.showStickyMessage(loginErrorHeader, messageContent, MessageSeverity.error, error);
              } else if (error && error.error && error.error.error && error.error.error == "access_denied") {
                this.alertService.showStickyMessage(loginErrorHeader, 'Sie haben keine Berechtigung.', MessageSeverity.warn, error);
              } else {
                let text = 'Beim Einloggen ist ein Fehler aufgetreten. Bitte versuchen Sie es später noch einmal. \nFehler: ' + error.statusText;
                this.alertService.showStickyMessage(loginErrorHeader, text, MessageSeverity.error, error);
              }
            }
          }

          setTimeout(() => {
            this.isLoading = false;
          }, 500);
        });
  }

  closeModal() {
    if (this.modalClosedCallback) {
      this.modalClosedCallback();
    }
  }

  getShouldRedirect() {
    return !this.isModal && this.authService.isLoggedIn && !this.authService.isSessionExpired;
  }

  reset() {
    this.formResetToggle = false;

    setTimeout(() => {
      this.formResetToggle = true;
    });
  }

}
